<template>
  <div class="index">
    <headerComponent />
    <img src="@/assets/images_member/Group 823@2x.png" class="img-bg" alt="">
    <div class="fixed-btn">
      <div class="left-btn" @click="handleJump('SHAREPOSTER')">
        <div class="btn-tips">推荐有奖</div>
        邀请好友
      </div>
      <div class="right-btn" @click="handleJump('OPENMENBER')">
        <img src="@/assets/images_member/per1 (33).png" class="icon-btn" alt="">
        去开通会员
      </div>
    </div>
  </div>
</template>
<script>
import headerComponent from '@/components/HeaderComponent.vue'
export default {
  name: 'home',
  components: {
    headerComponent,
  },
  data () {
    return {
      hasLoding: false,
    }
  },
  computed: {
    userInfo () {
      return JSON.parse(this.$ls.storage['xingfugongshe_user-info']).value
    },
  },
  created () { },
  mounted() {
  },
  methods: {
    handleJump (type) {
      let url = ''
      switch (type) {
        case 'SHAREPOSTER':
          this.$router.push({
            path: '/sharePoster'
          })
          break

        case 'OPENMENBER':
          this.$router.push({
            path: '/openMenber'
          })
          break
        default:
          break
      }
      setTimeout(() => {
        this.$router.push({
          path: url,
        })
      })
    },
  },
}
</script>
<style lang="less" scoped>
.index {
  width: 100vw;
  min-height: 100vh;
  background-color: #2F3131;

  .img-bg {
    width: 100%;
    top: 0;
    left: 0;
    position: absolute;
  }

  .fixed-btn {
    display: flex;
    justify-content: space-between;
    align-items: center;
    position: fixed;
    width: 100%;
    background-color: #2F3131;
    bottom: 0;
    left: 0;
    padding: 14px;
    box-sizing: border-box;

    .left-btn {
      position: relative;
      width: 166px;
      height: 48px;
      line-height: 48px;
      text-align: center;
      border: 1px solid #F0E1C0;
      border-radius: 100px;
      font-size: 16px;
      color: #F0E1C0;
      font-weight: 600;

      .btn-tips {
        position: absolute;
        width: 67px;
        height: 18px;
        line-height: 18px;
        text-align: center;
        font-size: 12px;
        color: #FFFFFF;
        font-weight: 500;
        background: linear-gradient(270deg, #FF621F 0%, #FAA72A 100%);
        border-radius: 100px 100px 100px 0;
        right: -8px;
        top: -2px;
      }
    }

    .right-btn {
      color: #504632;
      font-size: 18px;
      font-weight: 600;
      width: 166px;
      height: 48px;
      line-height: 48px;
      text-align: center;
      background: linear-gradient(109deg, #FFECD0 0%, #FFC387 100%);
      border-radius: 100px;
      position: relative;

      .icon-btn {
        position: absolute;
        bottom: 0;
        left: 82px;
        width: 98px;
        height: 95px;
        opacity: .3;
      }
    }
  }
}</style>



// WEBPACK FOOTER //
// src/views/pageHome.vue